import { format } from 'date-fns';

export function getDateWithTimezone(date: string): string {
    const timezoneOffset = new Date(date).getTimezoneOffset() * 60000;

    return new Date(new Date(date).getTime() + timezoneOffset).toISOString();
}

export function normalizeTimezone(date: Date): Date {
    return new Date(format(date, 'yyyy-MM-dd'));
}
